export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '香蕉视频平台是否免费使用？',
    answer: '是的，香蕉视频平台完全免费！您可以免费浏览所有视频内容、注册账号、上传和分享您的原创视频。我们致力于为每一位创作者提供平等的展示机会，让优质内容被更多人看到。未来我们会推出创作者激励计划，让优秀的创作者通过内容获得收益。',
  },
  {
    question: '如何在香蕉视频上发布我的第一个视频？',
    answer: '发布视频非常简单！注册账号后，点击页面右上角的"+"按钮或进入个人中心的"上传"页面，选择您要发布的视频文件，填写标题、简介、选择分类和标签，然后点击发布即可。我们支持MP4、MOV等多种格式，单个视频最大支持2GB。发布后我们的智能推荐系统会自动将您的视频推送给感兴趣的用户。',
  },
  {
    question: '视频发布后多久能通过审核？',
    answer: '我们的内容审核团队7x24小时不间断工作，正常情况下视频提交后30分钟内即可完成审核。审核通过后视频会立即出现在您的个人主页和相关分类中。为了维护良好的社区环境，请确保您的视频内容遵守平台社区规范，不包含违规内容。',
  },
  {
    question: '香蕉视频的推荐算法是如何工作的？',
    answer: '我们的智能推荐系统会综合分析用户的观看历史、点赞、评论、分享等行为数据，同时结合视频的内容标签、质量评分、创作者信誉等多维度信息，为每位用户精准推荐他们可能感兴趣的视频内容。系统还会不断学习和优化，推荐效果会随着使用时间越来越精准。',
  },
  {
    question: '我可以在多个设备上使用香蕉视频吗？',
    answer: '当然可以！香蕉视频支持Web网页版、iOS和Android移动端应用。您可以在手机、平板、电脑等设备上随时观看视频。登录同一个账号后，您的观看历史、收藏列表和个性化推荐会在所有设备上同步，打造无缝的跨设备体验。',
  },
  {
    question: '如何联系香蕉视频的客服团队？',
    answer: '您可以通过以下方式联系我们的客服团队：发送邮件至 support@bananavideo.cn，或访问"关于我们"页面使用在线联系表单提交您的问题。我们的客服团队工作时间为每天9:00-21:00，通常会在2小时内回复您的咨询。紧急问题请直接拨打客服热线：400-888-8888。',
  },
  {
    question: '香蕉视频对创作者有哪些扶持政策？',
    answer: '我们推出了全方位的创作者扶持计划「香蕉星计划」，包括：新人流量扶持——新创作者的前5个视频会获得额外曝光；优质内容奖励——月度热门视频TOP100的创作者可获得现金奖励；创作培训——定期举办线上创作技巧培训课程；商业合作——帮助优秀创作者对接品牌合作机会。',
  },
];